{
  "mar": {
    "title": "Catatan Pemberian Obat",
    "loading": "Memuat catatan pemberian obat...",
    "emptyState": "Tidak ada obat aktif untuk pasien ini",
    "loadError": "Gagal memuat obat-obatan",
    "retry": "Coba lagi",
    "previousDay": "Hari sebelumnya",
    "nextDay": "Hari berikutnya",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "Sif",
    "dayShiftHeader": "Sif Siang (07:00 - 19:00)",
    "nightShiftHeader": "Sif Malam (19:00 - 07:00)",
    "newOrder": "Resep Obat Baru",
    "printMar": "Cetak Catatan",
    "prnSection": "Obat PRN (bila perlu)",
    "filter": {
      "timeWindow": "Rentang waktu",
      "category": "Kategori",
      "status": "Status",
      "scheduledOnly": "Hanya yang terjadwal"
    },
    "adminStatus": {
      "scheduled": "Terjadwal",
      "dueNow": "Saatnya diberikan",
      "overdue": "Terlambat",
      "administered": "Diberikan",
      "held": "Ditunda",
      "refused": "Ditolak",
      "missed": "Terlewat"
    },
    "columns": {
      "medication": "Obat",
      "drug": "Obat",
      "doseRoute": "Dosis / Rute",
      "schedule": "Jadwal",
      "scheduledTime": "Waktu terjadwal",
      "givenTime": "Waktu pemberian",
      "givenBy": "Diberikan oleh",
      "status": "Status"
    },
    "actions": {
      "administer": "Berikan",
      "hold": "Tunda",
      "refuse": "Tolak",
      "skip": "Lewati",
      "missed": "Tandai terlewat",
      "edit": "Sunting pemberian",
      "viewHistory": "Lihat riwayat",
      "givePrn": "Berikan PRN"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "PERINGATAN TINGGI",
      "indication": "Indikasi: {{indication}}",
      "lastGiven": "Terakhir diberikan: {{time}}",
      "lastGivenBy": "Terakhir diberikan: {{time}} oleh {{user}}"
    },
    "orderBadge": {
      "active": "Aktif",
      "onHold": "Ditunda",
      "discontinued": "Dihentikan"
    },
    "legend": "Keterangan:",
    "summary": {
      "medsGivenToday": "Obat yang diberikan hari ini: ",
      "ofTotal": "{{given}} dari {{total}}",
      "overdueCount_one": "{{count}} terlambat",
      "overdueCount_other": "{{count}} terlambat",
      "nextDue": "Berikutnya: ",
      "nextDueAt": "{{medName}} pukul {{time}}"
    },
    "tooltip": {
      "given": "(diberikan {{time}})",
      "pending": "Merekam… belum dikonfirmasi oleh server"
    },
    "doseModal": {
      "title": "Beri Dosis",
      "doseGiven": "Dosis yang diberikan",
      "siteOfAdministration": "Lokasi pemberian",
      "comments": "Catatan",
      "vitalsCheck": "Tanda vital pra-pemberian",
      "doubleCheck": "Verifikasi dua klinisi",
      "verifier": "Pemverifikasi",
      "confirm": "Konfirmasi pemberian"
    },
    "administerDialog": {
      "doseLabel": "Dosis",
      "routeLabel": "Rute",
      "siteLabel": "Lokasi pemberian (bila perlu)",
      "site": {
        "notApplicable": "Tidak berlaku",
        "leftArm": "Lengan kiri",
        "rightArm": "Lengan kanan",
        "leftDeltoid": "Deltoid kiri",
        "rightDeltoid": "Deltoid kanan",
        "leftGluteal": "Bokong kiri",
        "rightGluteal": "Bokong kanan",
        "leftThigh": "Paha kiri",
        "rightThigh": "Paha kanan",
        "abdomen": "Abdomen"
      },
      "timeAdministered": "Waktu Pemberian",
      "administeredDateAria": "Tanggal pemberian",
      "administeredTimeAria": "Waktu pemberian",
      "notesLabel": "Catatan",
      "notesPlaceholder": "Catatan opsional..."
    },
    "prnWarning": {
      "title": "Peringatan Interval PRN",
      "lastDoseHoursAgo": "Dosis terakhir diberikan {{hours}} jam lalu.",
      "minimumInterval": "Interval minimum adalah {{hours}} jam.",
      "lastAdministered": "Terakhir diberikan: {{time}}",
      "justificationLabel": "Alasan pemberian lebih awal",
      "justificationRequired": "*",
      "justificationPlaceholder": "Masukkan alasan klinis untuk memberikan sebelum interval minimum...",
      "cancel": "Batal",
      "overrideContinue": "Timpa dan Lanjutkan"
    },
    "toast": {
      "administered": "Pemberian obat tercatat",
      "administerError": "Gagal mencatat pemberian",
      "administerNotImplemented": "Pencatatan MAR belum tersedia",
      "held": "Obat ditunda",
      "refused": "Penolakan pasien tercatat",
      "skipped": "Pemberian obat dilewati",
      "orderNotActive": "Instruksi ini sudah tidak aktif (dihentikan, dibatalkan, atau selesai) sehingga pemberian obat tidak dapat dicatat."
    },
    "holdRefuseDialog": {
      "holdTitle": "Tunda Obat",
      "refuseTitle": "Tolak Obat",
      "skipTitle": "Lewati Obat",
      "scheduledLabel": "Terjadwal: {{time}}",
      "holdReasonLabel": "Alasan menunda",
      "refusalNotesLabel": "Catatan penolakan",
      "skipReasonLabel": "Alasan melewati",
      "holdReasonPlaceholder": "Masukkan alasan menunda...",
      "refusalPlaceholder": "Dokumentasikan penolakan pasien...",
      "skipPlaceholder": "Masukkan alasan melewati...",
      "cancel": "Batal",
      "confirm": "Konfirmasi"
    },
    "contextMenu": {
      "hold": "Tunda",
      "refuse": "Tolak",
      "skip": "Lewati"
    },
    "holdReason": {
      "label": "Alasan menunda",
      "options": {
        "patientNpo": "Pasien NPO (puasa)",
        "vitalsOutOfRange": "Tanda vital di luar rentang",
        "patientRefused": "Pasien menolak",
        "providerOrder": "Perintah dokter untuk menunda",
        "other": "Lainnya"
      }
    },
    "give": {
      "title": "Beri · {{medication}} {{dose}}",
      "scheduledLabel": "Terjadwal {{time}}",
      "patientLabel": "Pasien",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "ID Pasien: {{id}}",
      "medicationLabel": "Obat",
      "scanPatientPlaceholder": "Pindai gelang pasien",
      "scanPatientAria": "Pindai gelang identitas pasien",
      "scanMedicationPlaceholder": "Pindai barcode kemasan obat",
      "scanMedicationAria": "Pindai kemasan obat",
      "patientMismatch": "Gelang ini bukan milik pasien ini. Jangan berikan obat.",
      "medicationMismatch": "Kemasan ini bukan obat yang diresepkan. Jangan berikan obat.",
      "notScannable": "Tidak dapat diverifikasi dengan pemindaian — tidak ada barcode terdaftar untuk order ini",
      "overrideReason": "Alasan memberikan obat tanpa pemindaian",
      "overrideReasonPlaceholder": "mis. gelang rusak; dosis racikan tanpa barcode",
      "pharmacyOverride": "Farmasi belum memverifikasi obat kewaspadaan tinggi ini",
      "pharmacyOverridePlaceholder": "Mengapa dosis ini tidak dapat menunggu telaah farmasi?",
      "timeLabel": "Waktu",
      "detailsEdit": "Ubah",
      "detailsDone": "Selesai",
      "confirmLabel": "Data ini sesuai dengan order dan dosis yang saya pegang",
      "cancel": "Batal",
      "submit": "Beri",
      "witness": {
        "banner": "PERINGATAN TINGGI — perlu pemeriksaan ganda oleh perawat kedua",
        "usernameLabel": "Nama pengguna perawat kedua",
        "passwordLabel": "Kata Sandi",
        "verify": "Verifikasi",
        "verifying": "Memverifikasi…",
        "verified": "Telah diperiksa ganda oleh perawat kedua",
        "rejected": "Kredensial tidak dikenali.",
        "overrideLabel": "Tidak ada perawat kedua? Berikan tanpa pemeriksaan ganda — alasan",
        "overridePlaceholder": "Mengapa dosis ini tidak dapat menunggu pemeriksaan ganda independen?"
      },
      "refusal": {
        "wrongPatient": "Pasien salah — gelang yang dipindai tidak cocok dengan order ini. Jangan berikan obat.",
        "wrongMedication": "Obat salah — kemasan yang dipindai tidak cocok dengan obat yang diresepkan. Jangan berikan obat.",
        "scanRequired": "Pindai gelang dan obat, atau berikan alasan tidak memindai.",
        "pharmacyVerificationRequired": "Farmasi belum memverifikasi order ini. Tunggu verifikasi, atau catat alasan tidak dapat menunggu.",
        "doubleCheckRequired": "Belum ada perawat kedua yang memeriksa ganda order ini. Mintakan pemeriksaan tersebut, atau catat alasan tidak dapat menunggu.",
        "doubleCheckSelf": "Anda tidak dapat memeriksa ganda pemberian obat Anda sendiri. Perawat kedua harus memverifikasi dosis ini."
      },
      "dispense": {
        "handedOver": "{{quantity}} diserahkan {{time}}",
        "label": "Penyerahan farmasi",
        "none": "Tidak ada catatan penyerahan untuk pesanan ini",
        "pending": "Penyerahan tercatat, belum diserahkan",
        "prepared": "{{quantity}} disiapkan {{time}}",
        "unavailable": "Tidak dapat memeriksa penyerahan — catatan tidak terjangkau"
      }
    }
  },
  "status": {
    "active": "Aktif",
    "held": "Ditunda",
    "discontinued": "Dihentikan",
    "completed": "Selesai",
    "refused": "Ditolak",
    "missed": "Terlewat",
    "given": "Diberikan"
  },
  "route": {
    "po": "Oral",
    "iv": "Intravena",
    "im": "Intramuskular",
    "sc": "Subkutan",
    "in": "Intranasal",
    "pr": "Per rektal",
    "sl": "Sublingual",
    "top": "Topikal",
    "neb": "Nebulisasi",
    "pv": "Per vagina",
    "ng": "Nasogastrik",
    "ophthalmic": "Oftalmik",
    "transdermal": "Transdermal"
  },
  "frequency": {
    "bid": "Dua kali sehari",
    "tid": "Tiga kali sehari",
    "qid": "Empat kali sehari",
    "qd": "Sekali sehari",
    "qhs": "Sebelum tidur",
    "prn": "Bila perlu (PRN)",
    "stat": "Segera (STAT)",
    "continuous": "Berkelanjutan"
  },
  "formulary": {
    "title": "Formularium Obat",
    "searchPlaceholder": "Cari berdasarkan nama obat, nama generik, atau kode...",
    "clearSearch": "Hapus pencarian",
    "category": {
      "all": "Semua",
      "analgesic": "Analgesik",
      "antibiotic": "Antibiotik",
      "antifungal": "Antijamur",
      "antiviral": "Antivirus",
      "cardiac": "Kardiovaskular",
      "endocrine": "Endokrin",
      "gi": "Gastrointestinal",
      "neurological": "Neurologi",
      "psychiatric": "Psikiatri",
      "respiratory": "Respirasi",
      "other": "Lainnya"
    },
    "columns": {
      "medication": "Obat",
      "genericName": "Nama Generik",
      "form": "Bentuk",
      "strength": "Kekuatan",
      "route": "Rute Pemberian",
      "status": "Status",
      "schedule": "Golongan"
    },
    "highAlertBadge": "Obat Kewaspadaan Tinggi",
    "highAlertTag": "Kewaspadaan Tinggi",
    "status": {
      "preferred": "Dianjurkan",
      "restricted": "Dibatasi",
      "nonFormulary": "Non-Formularium"
    },
    "loading": "Memuat formularium...",
    "loadError": "Gagal memuat formularium",
    "empty": "Tidak ada obat ditemukan.",
    "pagination": {
      "showing": "Menampilkan {{from}}-{{to}} dari {{total}}",
      "page": "Halaman {{page}} dari {{totalPages}}",
      "previous": "Halaman sebelumnya",
      "next": "Halaman berikutnya"
    },
    "details": {
      "close": "Tutup detail",
      "genericName": "Nama Generik",
      "category": "Kategori",
      "formStrength": "Bentuk / Kekuatan",
      "route": "Rute Pemberian",
      "formularyStatus": "Status Formularium",
      "deaSchedule": "Golongan DEA",
      "indications": "Indikasi",
      "contraindications": "Kontraindikasi",
      "interactions": "Interaksi Obat",
      "sideEffects": "Efek Samping",
      "dosageGuidelines": "Panduan Dosis",
      "specialPopulations": "Populasi Khusus",
      "storage": "Penyimpanan"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "Antrian Verifikasi Apoteker",
    "subtitle": "Tinjau dan verifikasi instruksi obat yang tertunda",
    "pendingCount": "{{count}} tertunda",
    "refresh": "Muat Ulang",
    "searchPlaceholder": "Cari berdasarkan obat, nama pasien, atau MRN...",
    "priority": {
      "all": "Semua Prioritas",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Rutin",
      "scheduled": "Terjadwal"
    },
    "loadError": "Gagal memuat antrian obat",
    "retry": "Coba Lagi",
    "empty": {
      "title": "Semua sudah selesai",
      "description": "Tidak ada instruksi obat yang menunggu verifikasi."
    },
    "columns": {
      "patient": "Pasien",
      "medication": "Obat",
      "doseRouteFreq": "Dosis / Rute / Frekuensi",
      "priority": "Prioritas",
      "orderingProvider": "Dokter Pemberi Instruksi",
      "ordered": "Waktu Instruksi",
      "actions": "Tindakan"
    },
    "row": {
      "unknown": "Tidak diketahui",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "Terkontrol {{schedule}}",
      "providerFallback": "Dokter #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "Verifikasi",
      "verifyTooltip": "Verifikasi instruksi obat ini",
      "reject": "Tolak",
      "rejectTooltip": "Tolak dan hentikan",
      "confirmReject": "Konfirmasi",
      "cancelReject": "Batal",
      "rejectReasonPlaceholder": "Alasan penolakan..."
    },
    "toast": {
      "verifySuccess": "Obat #{{id}} diverifikasi",
      "verifyError": "Gagal memverifikasi obat",
      "rejectSuccess": "Obat #{{id}} ditolak dan dihentikan",
      "rejectError": "Gagal menolak obat",
      "rejectReasonRequired": "Mohon berikan alasan penolakan",
      "notIndependent": "Peresep tidak boleh memverifikasi pesanannya sendiri.",
      "overrideSuccess": "Order {{id}} diaktifkan tanpa verifikasi apoteker",
      "overrideError": "Tidak dapat mencatat penimpaan",
      "overrideReasonRequired": "Penimpaan memerlukan kode alasan dan justifikasi"
    },
    "verifyDialog": {
      "title": "Verifikasi pesanan obat",
      "instruction": "Konfirmasi setiap pemeriksaan yang Anda selesaikan. Keempatnya wajib — tinjauan sebagian bukan verifikasi.",
      "checks": {
        "allergy": "Saya meninjau pesanan ini terhadap alergi pasien",
        "interaction": "Saya meninjau interaksi antarobat",
        "duplicateTherapy": "Saya meninjau terapi ganda",
        "doseRange": "Saya meninjau dosis untuk pasien ini"
      },
      "cancel": "Batal",
      "confirm": "Verifikasi"
    },
    "override": {
      "action": "Timpa",
      "confirm": "Catat penimpaan",
      "cancel": "Batal",
      "tooltip": "Lanjutkan tanpa verifikasi apoteker. Alasan dicatat; tidak memenuhi pemeriksaan farmasi untuk obat kewaspadaan tinggi.",
      "codeLabel": "Kode alasan penimpaan",
      "codePlaceholder": "Pilih alasan…",
      "justificationLabel": "Justifikasi penimpaan",
      "justificationPlaceholder": "Mengapa dilanjutkan tanpa telaah farmasi?",
      "code": {
        "pharmacyClosed": "Farmasi tutup",
        "urgentClinicalNeed": "Kebutuhan klinis mendesak",
        "pharmacyUnreachable": "Farmasi tidak dapat dihubungi"
      }
    },
    "clarify": {
      "action": "Klarifikasi",
      "tooltip": "Farmasi memasukkan order ini berbeda. Selesaikan sebelum obat dapat diberikan.",
      "heading": "Farmasi memasukkannya berbeda",
      "holding": "(menahan order)",
      "upheld": "Order tetap",
      "upheldTooltip": "Order asli benar; siapkan sesuai tertulis.",
      "amended": "Sudah saya ubah",
      "amendedTooltip": "Catat bahwa order telah diubah.",
      "adopt": "Terima versi farmasi",
      "adoptTooltip": "Terima versi terenkode berdasarkan perjanjian praktik kolaboratif atau protokol P&T.",
      "close": "Tutup",
      "toast": {
        "resolved": "Klarifikasi selesai; order kembali untuk verifikasi",
        "error": "Klarifikasi tidak dapat diselesaikan"
      }
    }
  },
  "reconciliation": {
    "title": "Rekonsiliasi Obat",
    "subtitle": "{{patient}} | {{mrn}} | Kunjungan #{{encounter}}",
    "complete": "Selesaikan Rekonsiliasi",
    "loading": "Memuat obat...",
    "column": {
      "home": "Obat dari Rumah",
      "inpatient": "Obat Rawat Inap",
      "discharge": "Obat Pulang"
    },
    "emptyHome": "Tidak ada obat dari rumah.",
    "emptyInpatient": "Tidak ada obat rawat inap.",
    "emptyDischarge": "Belum ada obat pulang. Pilih lanjutkan atau ubah obat dari kolom lain.",
    "changedFromHome": "Berubah dari obat di rumah",
    "action": {
      "continue": "Lanjut",
      "modify": "Ubah",
      "discontinue": "Hentikan",
      "discontinueShort": "D/C",
      "newOrder": "Baru"
    },
    "addToDischarge": "Tambah ke obat pulang",
    "remove": "Hapus",
    "modifyForm": {
      "title": "Ubah Obat",
      "dose": "Dosis",
      "route": "Rute Pemberian",
      "frequency": "Frekuensi",
      "dosePlaceholder": "mis. 500mg",
      "routePlaceholder": "mis. PO",
      "frequencyPlaceholder": "mis. BID",
      "cancel": "Batal",
      "save": "Simpan"
    },
    "back": "Kembali",
    "toast": {
      "completed": "Rekonsiliasi obat selesai",
      "completeError": "Gagal menyelesaikan rekonsiliasi",
      "atLeastOne": "Mohon rekonsiliasi minimal satu obat sebelum menyelesaikan"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "Kalkulator Dosis",
      "weightLabel": "Berat Badan Pasien (kg) *",
      "heightLabel": "Tinggi (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "mis. 70",
      "heightPlaceholder": "mis. 170",
      "gfrPlaceholder": "Opsional",
      "bsaLabel": "BSA Terhitung (Mosteller):",
      "calculate": "Hitung Dosis",
      "error": "Gagal menghitung dosis. Backend mungkin tidak memiliki data dosis untuk obat ini.",
      "renalAdjustment": "Penyesuaian Ginjal:",
      "originalDose": "Dosis asli:",
      "min": "Min:",
      "max": "Maks:",
      "recommended": "Disarankan: {{dose}} {{unit}}",
      "apply": "Terapkan Dosis",
      "method": {
        "weightBased": "Berbasis Berat Badan",
        "bsaBased": "Berbasis BSA",
        "flat": "Dosis Tetap",
        "renalAdjusted": "Disesuaikan Ginjal"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "Resepkan Obat",
    "submit": "Resepkan",
    "navButton": "Resepkan",
    "noActiveEncounter": "Resep harus dilampirkan pada kunjungan aktif. Buka atau daftarkan pasien ini ke suatu kunjungan sebelum meresepkan.",
    "fields": {
      "medication": "Obat",
      "dose": "Dosis",
      "doseUnit": "Satuan",
      "route": "Rute",
      "frequency": "Frekuensi",
      "frequencyDescription": "Keterangan frekuensi",
      "duration": "Durasi",
      "durationUnit": "Satuan durasi",
      "totalDoses": "Total dosis",
      "isPrn": "PRN (bila perlu)",
      "prnIndication": "Indikasi PRN",
      "administrationInstructions": "Instruksi pemberian",
      "patientInstructions": "Instruksi pasien",
      "quantityDispensed": "Jumlah diserahkan",
      "refillsAuthorized": "Pengisian ulang yang diizinkan",
      "allowSubstitution": "Izinkan substitusi generik",
      "pharmacyNotes": "Catatan apotek",
      "indication": "Indikasi",
      "clinicalIndication": "Indikasi klinis",
      "priority": "Prioritas"
    },
    "sections": {
      "drug": "Obat",
      "dosing": "Dosis",
      "durationPrn": "Durasi & PRN",
      "instructions": "Instruksi",
      "dispensing": "Penyerahan",
      "clinical": "Klinis"
    },
    "doseUnitPlaceholder": "mis. mg",
    "drugSearch": {
      "placeholder": "Cari formularium…",
      "noResults": "Tidak ada obat formularium yang cocok",
      "clear": "Hapus pilihan",
      "catalogRequired": "Pilih obat dari formularium untuk diresepkan",
      "catalogOnly": "Hanya obat formularium yang dapat diresepkan, agar setiap pemeriksaan keamanan dapat berjalan.",
      "controlledBadge": "Terkontrol — Golongan {{schedule}}",
      "controlledTag": "Terkontrol",
      "highAlertBadge": "Obat Kewaspadaan Tinggi",
      "highAlertTag": "Kewaspadaan Tinggi",
      "contraindications": "Kontraindikasi: {{text}}"
    },
    "route": {
      "oral": "Oral (PO)",
      "iv": "Intravena (IV)",
      "subcutaneous": "Subkutan (SC)",
      "intramuscular": "Intramuskular (IM)",
      "topical": "Topikal",
      "inhalation": "Inhalasi",
      "rectal": "Rektal (PR)",
      "ophthalmic": "Oftalmik",
      "transdermal": "Transdermal"
    },
    "frequency": {
      "QD": "Sekali sehari (QD)",
      "BID": "Dua kali sehari (BID)",
      "TID": "Tiga kali sehari (TID)",
      "QID": "Empat kali sehari (QID)",
      "Q4H": "Setiap 4 jam (Q4H)",
      "Q6H": "Setiap 6 jam (Q6H)",
      "Q8H": "Setiap 8 jam (Q8H)",
      "Q12H": "Setiap 12 jam (Q12H)",
      "QHS": "Sebelum tidur (QHS)",
      "PRN": "Bila perlu (PRN)",
      "STAT": "Segera (STAT)"
    },
    "durationUnit": {
      "days": "Hari",
      "weeks": "Minggu",
      "months": "Bulan",
      "doses": "Dosis"
    },
    "priority": {
      "routine": "Rutin",
      "asap": "Sesegera mungkin",
      "stat": "Segera"
    },
    "validation": {
      "prnIndicationRequired": "Indikasi PRN diperlukan untuk pesanan bila perlu"
    },
    "contextBar": {
      "ariaLabel": "Konteks peresepan",
      "allergies": {
        "label": "Alergi",
        "none": "Tidak ada alergi yang diketahui",
        "severe": "Berat"
      },
      "weight": {
        "label": "Berat badan",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "Tidak tercatat"
      },
      "renal": {
        "label": "Fungsi ginjal",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "Fungsi ginjal tidak diketahui",
        "source": {
          "reported": "dilaporkan",
          "computed": "dihitung",
          "unknown": "tidak diketahui"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "Obat telah diresepkan",
      "error": "Tidak dapat membuat order. Silakan coba lagi.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "Diresepkan dengan peringatan keselamatan",
      "continue": "Lanjutkan"
    },
    "safetyReview": {
      "title": "Tinjauan Keselamatan Diperlukan",
      "proceed": "Timpa & Resepkan",
      "cancel": "Batal",
      "reasonPrompt": "Pilih alasan penggantian…",
      "freeTextLabel": "Detail tambahan",
      "freeTextPlaceholder": "Tambahkan konteks klinis (opsional)",
      "hardBlockNote": "Blok ini tidak dapat ditimpa.",
      "cannotOverride": "Resep ini tidak dapat dilanjutkan — satu atau lebih blok tidak dapat ditimpa.",
      "blockKind": {
        "cds_contraindication": "Kontraindikasi",
        "cds_unavailable": "Skrining keselamatan tidak tersedia",
        "renal_contraindication": "Kontraindikasi ginjal",
        "dose_range": "Dosis di luar rentang yang direkomendasikan",
        "pregnancy_contraindication": "Risiko kehamilan",
        "unknown": "Blok keselamatan tambahan"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "Riwayat ditinjau secara manual",
        "NO_KNOWN_RISK_THIS_PATIENT": "Tidak ada risiko yang diketahui untuk pasien ini",
        "URGENT_CLINICAL_NEED": "Kebutuhan klinis mendesak",
        "OTHER": "Lainnya (jelaskan)",
        "BENEFIT_OUTWEIGHS_RISK": "Manfaat lebih besar dari risiko",
        "DOSE_REDUCED_PER_PROTOCOL": "Dosis dikurangi sesuai protokol",
        "EGFR_NOT_REPRESENTATIVE": "eGFR tidak representatif",
        "SPECIALIST_ADVICE": "Saran spesialis",
        "PATIENT_TOLERANT": "Pasien toleran terhadap dosis ini",
        "SPECIALIST_PROTOCOL": "Sesuai protokol spesialis",
        "TITRATING_TO_EFFECT": "Titrasi sesuai efek",
        "RANGE_NOT_APPLICABLE": "Rentang tidak berlaku",
        "STATUS_CONFIRMED_NEGATIVE": "Status kehamilan dikonfirmasi negatif",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "Manfaat melebihi risiko pada janin",
        "CONTRACEPTION_CONFIRMED": "Kontrasepsi efektif dikonfirmasi",
        "PREGNANCY_BEING_TERMINATED": "Kehamilan sedang dihentikan"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
